export default __webpack_public_path__ + "static/media/img-0217-mexico-half-face.b8168502.png";